import { map } from 'rxjs/operators';
import { EventGuest } from '../../../shared/models/events/guests/event-guest.model';
import { EventGuestDetails } from '../../../shared/models/events/guests/event-guest-details.model';

export function guestFillDetailsPipe() {
    return map((guests: EventGuest[]) =>
        guests.map(g => {
            if (!g.details) {
                g.details = {
                    event_guest_id: g.id,
                    guest: g,
                    name: g.name,
                    surname: g.surname,
                    lastname: g.lastname,
                    gender: 'N', 
                    position: g.position,
                    group1Name: g.position_group_name,
                    groupColor: g.color,
                    effectivePositionOrder: g.effective_position_order,
                    tags: ''
                } as EventGuestDetails;
            }
            return g;
        })
    );
}

